<template>
  <div id="app">
    <div v-wechat-title="headerTitle" img-set=" "></div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import { AppCallback, AppOperate } from '@/utils/appfunc'
import browser from '@/utils/browser'
import { mapGetters } from 'vuex'
import NeedLogin from '@/views/home/register/needLogin'
import { hospitalAuthListAll } from "@/api/information";
import { wxGetSignature } from '@/api/wx'
import {wxConfig} from '@/utils/wx'
export default {
  components: { NeedLogin },
  async created() {
    if (JSON.parse(localStorage.getItem('hospitalAuthList'))) {

    } else {
      let list = await this.getHospitalAuthListAll()
      this.$store.commit('changeHospitalAuthList', list)
      localStorage.setItem("hospitalAuthList", JSON.stringify(list))
    }
    this.wxConfig()
  },
  mounted() {

    console.log('headerTitle',this.headerTitle); 
    AppOperate.getNotchPhone(res => {
      let obj = JSON.parse(res)
      if (obj.hasNotch) {
        if (obj.isX) {
          this.$store.commit('changeIphoneX', true)
        } else {
          this.$store.commit('changeHasNotch', true)
        }
      }
    })

    if (browser.versions.weChat || browser.versions.Ali) {
      this.$store.commit('changeWeChat', true)
    } else {
      this.$store.commit('changeWeChat', false)
    }
  },
  computed: {
    ...mapGetters({
      headerTitle: 'getHeaderTitle'
    }),
    haslogin() {
      return localStorage.getItem('userData')
    },
    isWhiteList() {
      let whiteList = [
        '/',
        '/index',
        '/index/user',
        '/login',
        '/register',
        '/agreement1',
        '/agreement2',
        '/wechat_login',
        '/information',
        '/informationContent'
      ]
      return whiteList.includes(this.$route.path)
    }
  },
  methods: {
    // touchmove (e) {
    //   e.preventDefault()
    // }

    //项目一启动就调用微信配置
    wxConfig() {
     
         //判断当前环境
      if (browser.versions.weChat) {

        let url = location.href
        wxGetSignature({
        url: url
       })
        .then(function (res) {
          let data = res
          wxConfig({debug:false,appId:data.appId,timestamp:data.timestamp,nonceStr:data.nonceStr,signature:data.signature})
        })
        .catch(err => {
          console.log(err)
        })
        
      }
    },


    //医院列表数据
    getHospitalAuthListAll() {
      return new Promise((resolve, reject) => {
        hospitalAuthListAll()
          .then(res => {
            let list = res.lists.map(item => ({
              hospitalCode: item.hospitalCode,
              list: JSON.parse(item.list)
            }));
            resolve(list)
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  },


}
</script>



// WEBPACK FOOTER //
// src/App.vue